import Text from '../../Text'

import { formatChatroomSystemMessageTime } from './ChatroomSystemMessage.utils'
import { ChatroomSystemMessageContent } from './ChatroomSystemMessageContent'

import * as styles from './ChatroomSystemMessage.module.css'

function ChatroomSystemMessage({ message }) {
  const timeLabel = formatChatroomSystemMessageTime(message.created)

  return (
    <div className={styles.row}>
      <Text isSecondary className={styles.time}>
        {timeLabel}
      </Text>
      <Text isSecondary className={styles.text}>
        <ChatroomSystemMessageContent message={message} />
      </Text>
    </div>
  )
}

export default ChatroomSystemMessage
